import { connect } from 'react-redux'

// import { openRegisterModal } from 'Modules/modals/actions'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import {
  removeCompareListing, addCompareListing,
  toggleCompareGrid,
} from 'Modules/compare/actions'
import CompareCta from './CompareCta'

const mapStateToProps = state => ({
  comparedListings: state.compare.comparedListings,
  userIsAuthentificated: state.userData.userIsAuthentificated,
})

const actions = {
  addCompareListing,
  removeCompareListing,
  toggleCompareGrid,
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(CompareCta)
